export default "__VITE_ASSET__69f49db9__"